import FileTextIconOutlined from 'components/icons/FileTextIconOutlined';
import { FeatureGuide } from '../types';
import { howItHelps, tips, whatItIs } from './sections';

export const ensFormGuide: FeatureGuide = {
    key: 'ensForm',
    title: 'Form',
    icon: <FileTextIconOutlined />,
    sections: [
        whatItIs(
            'The transport mode of the movement and the ICS2 message type used to lodge this entry summary declaration.'
        ),
        howItHelps(
            'The transport mode decides which ICS2 form applies, and the form decides which data elements customs expects on the declaration.'
        ),
        tips([
            'Road movements are filed as F50, maritime movements as F11.',
            'When the manifest already states the movement type, the transport mode is filled in for you.',
        ]),
    ],
};
